import { LanguagesEnum } from '../../../config/languages';

export const Translations = {
  language: {
    [LanguagesEnum.English]: 'Language',
    [LanguagesEnum.Greek]: 'Γλώσσα',
  },
};

const Configuration = {
  visible: false,
};

export default Configuration;
